
export function wpServicesToJsServices(services) {
    function normalizeExtras(service) {
        let newExtras = [];
        if (service.extras) {
            service.extras.forEach((item) => {
                newExtras.push({
                    title: item.title,
                    price: item.price,
                })
            })
        }
        return newExtras;
    }
    return services.map((item) => {
        return {
            wpid: item.id,
            id: item.id,
            title: item.title,
            description: item.description,
            price: {
                value: item.price.value,
                append: item.price.append,
                prepend: item.price.prepend,
            },
            sales_price: {
                value: item.sales_price && item.sales_price.value || 0,
                append: item.sales_price && item.sales_price.append || '',
                prepend: item.sales_price && item.sales_price.prepend || '',
            },
            is_on_sale: item.is_on_sale,
            is_hidden_from_list: item.is_hidden_from_list,
            duration: {
                value: item.duration.value,
                append: item.duration.append,
            },
            instructions: item.instructions,
            category: item.category,
            extras: normalizeExtras(item),
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/components/bookingUtils.js